import type { ClientTerminology } from '@/views/list/NetworkTerms';
import { capAndFormatNumber } from '@/helpers/numbers';

/** Abbreviated USD, e.g. "$3.4M". */
export const formatWildfireCurrency = (value: number): string =>
  capAndFormatNumber(value, {
    style: 'currency',
    currency: 'USD',
    maximumSignificantDigits: 3,
    capAt: 999,
    suffix: '',
  });

/** Abbreviated USD with the "/year" suffix, e.g. "$3.4M/year". */
export const formatWildfireRisk = (
  value: number,
  intl: ClientTerminology
): string =>
  `${formatWildfireCurrency(value)}${intl.formatMessage({
    id: 'program.overview.stats.perYear',
  })}`;
